import * as o from "react";
import a from "../lib/IconBase.es.js";
import f from "../defs/ArrowLeft.es.js";
const r = o.forwardRef((e, t) => /* @__PURE__ */ o.createElement(a, { ref: t, ...e, weights: f }));
r.displayName = "ArrowLeftIcon";
const s = r;
export {
  s as ArrowLeft,
  r as ArrowLeftIcon
};
